import { useCreateUserPasswordResetRequestMutation as useCreateUserPasswordResetRequest } from '../types'
export default useCreateUserPasswordResetRequest
